import { Container, Row, Col, Image, Button } from "react-bootstrap";
import {
  BadgeBanner,
  TopRatedBadge,
  RatedBadgeWrapper,
  RatedBadgeLeft,
  RatedBadgeRight,
  RatedTitle,
  RatedText,
  StatisticsSection,
  StatisticsRight,
  StatisticsWrapper,
  StatisticsTitle,
  AmountCol,
  StatisticsText,
} from "./greatNonprofitsBadgeStyle";
import Badge from "../../../assests/images/badge-lg.webp";
import StatisticsLeftImage from "../../../assests/images/statisticsimg1.webp";
import StatisticsRightImage from "../../../assests/images/statisticsimg2.webp";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { badgeStatisticsHandler } from "../../../redux/slices/nonProfit/badge-statistics";
import {
  Title,
  WriteReviewSection,
  ReviewText,
  ReviewRightSection,
  RightBanner,
} from "../../../components/common/commonSubBanner/commonSubBannerStyle";
import GreatNonprofitsBadgeBanner from "../../../assests/images/nonprofitbanner.webp";
import { MESSAGE } from "../../../utils/message";
import MetaComponent from "../../../components/common/metaComponent";

const GreatNonprofitsBadge = () => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const statistics = useSelector((state: any) => state?.badgeStatistics?.data);

  useEffect(() => {
    dispatch(badgeStatisticsHandler());
  }, []);
  return (
    <>
      <MetaComponent
        keywords=""
        description=""
        ogTitle="GreatNonprofits Review and Top-Rated Badges | GreatNonprofits"
        ogDescription=""
        ogUrl="https://www.about.greatnonprofits.org/greatnonprofits-badge"
        ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
      />

      <>
        <BadgeBanner>
          <WriteReviewSection className="great-nonprofits-badge-banner">
            <Container className="cont-w">
              <Row>
                <Col lg={7} sm={12} md={12}>
                  <Title className="great-non-profits-title">
                    {MESSAGE.theGreatNonprofitsBadge}
                  </Title>
                  <ReviewText>
                    <strong className="strong-txt">
                      The mark of a nonprofit committed to transparency.
                    </strong>
                  </ReviewText>
                  <ReviewText className="text-great">
                    The GreatNonprofits Badge gives instant visual feedback to
                    visitors allowing them to see at a glance that your business
                    is committed to transparency. With one click, visitors can
                    easily read and submit reviews about your organization, as
                    well as view your detailed profile that includes valuable
                    information.
                  </ReviewText>
                  <ReviewText className="text-great">
                    {" "}
                    Putting the GreatNonprofits Badge on your site is just a
                    matter of cutting and pasting-Simply go to your nonprofit
                    profile page and click on the{" "}
                    <strong>'Get link or badge'</strong> on the left hand
                    column.
                  </ReviewText>
                </Col>
                <Col lg={5} sm={12} md={12}>
                  <RightBanner className="left_banner">
                    <ReviewRightSection>
                      <Image
                        src={GreatNonprofitsBadgeBanner}
                        alt="ReviewImage"
                      />
                      <Image
                        src={GreatNonprofitsBadgeBanner}
                        alt="ReviewImage"
                      />
                    </ReviewRightSection>
                  </RightBanner>
                </Col>
              </Row>
            </Container>
          </WriteReviewSection>
        </BadgeBanner>

        <TopRatedBadge>
          <Container className="cont-w">
            <RatedBadgeWrapper>
              <RatedBadgeLeft>
                <RatedTitle> {MESSAGE.topRatedBadgeText}</RatedTitle>
                <RatedText>
                  <strong> Get Visibility and Gain Trust</strong>
                </RatedText>
                <RatedText>
                  {" "}
                  All 2024 Top-Rated Nonprofits willget a Top-Rated certificate,
                  and a <strong>FREE</strong> Top-Rated badge on their
                  GreatNonprofits profile. This badge can be used on your own
                  website and marketing materials and will show in search
                  results on GreatNonprofits.org and on your nonprofit's profile
                  page.{" "}
                </RatedText>
                <RatedText>
                  {" "}
                  The GreatNonprofits Top-Rated badge is{" "}
                  <strong>
                    one of the most trusted rating seals for donors,
                  </strong>{" "}
                  according to a study conducted by{" "}
                  <a href="#!" onClick={() => navigate("/blogs/1")}>
                    <span>Software Advice.</span>
                  </a>
                </RatedText>
                <Button
                  className="btn-outline-success-blue"
                  onClick={() => navigate("/detail-award")}
                >
                  {MESSAGE.becomeTopRatedNonproofit}
                </Button>
              </RatedBadgeLeft>

              <RatedBadgeRight>
                <Image src={Badge} />
              </RatedBadgeRight>
            </RatedBadgeWrapper>

            <StatisticsSection>
              <RatedTitle> {MESSAGE.statistics}</RatedTitle>
              <StatisticsWrapper>
                {statistics?.data?.map((st: any, index: number) => (
                  <StatisticsRight key={index + 1}>
                    <StatisticsTitle>
                      <AmountCol>{st.statistic}</AmountCol>
                      <StatisticsText>{st.info}</StatisticsText>
                    </StatisticsTitle>
                    <Image
                      src={
                        st.name === "donorReview"
                          ? StatisticsLeftImage
                          : StatisticsRightImage
                      }
                      alt="StatisticsRightImage"
                    />
                  </StatisticsRight>
                ))}
              </StatisticsWrapper>
            </StatisticsSection>
          </Container>
        </TopRatedBadge>
      </>
    </>
  );
};
export default GreatNonprofitsBadge;
